
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import LoanTypes from './components/LoanTypes';
import LoanProcess from './components/LoanProcess';
import Requirements from './components/Requirements';
import LoanApplication from './components/LoanApplication';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServicesHero />
        <LoanTypes />
        <LoanProcess />
        <Requirements />
        <LoanApplication />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
